/**
 * Created by a555325 on 21/05/2018.
 */

import './riskminder/riskminder';
import storeManager from './StorageManager';

document.addEventListener('DOMContentLoaded', () => {
  generateMFP();
});

var generateMFP = () => {
  let keyName = 'deviceMFP';
  let mfp = storeManager.retrieve(keyName);
  if (!mfp) {
    mfp = generateMFPWithArcotClient();
    storeMFPInSessionStorage(keyName, mfp);
    return mfp;
  }
  if (!validateMFP(mfp)) {
    mfp = generateMFPWithArcotClient();
    storeMFPInSessionStorage(keyName, mfp);
    return mfp;
  }
  return mfp;
};

const storeMFPInSessionStorage = (keyName, deviceDNA) => {
  storeManager.save(keyName, deviceDNA);
};

const validateMFP = mfp => {
  try {
    var deviceMFP = JSON.parse(mfp);
    return ((deviceMFP || {}).MFP || {}).Browser ? true : false;
  } catch (error) {
    console.log(error);
  }
  return false;
};

const generateMFPWithArcotClient = () => {
  var arcotClient = new window.arcotrf.ArcotRFClient();
  arcotClient.analyzeDeviceDNA(() => {});
  var deviceDNA = arcotClient.getDNAString('json');
  return deviceDNA;
};

export default class RiskMinder {
  static getMFP() {
    // console.log('RiskMinder.js');
    let t1 = performance.now();
    let MFP = generateMFP();
    let t2 = performance.now();
    console.log('MFP Returned --------- in ', t2 - t1, 'ms');
    return JSON.stringify(MFP);
  }

  static getMFPasJSON() {
    return JSON.parse(generateMFP());
  }

  static validateDeviceMFP(mfp) {
    return validateMFP(JSON.parse(mfp));
  }

  static validateJSONMFP(mfp) {
    let mfpFormatted = JSON.stringify(mfp);
    return validateMFP(mfpFormatted);
  }

  static removeStoredMFP() {
    let keyName = 'deviceMFP';
    storeManager.remove(keyName);
  }

  static setDeviceId(deviceId) {
    storeManager.save('deviceId', deviceId);
  }

  static getDeviceId() {
    return storeManager.retrieve('deviceId');
  }
}



// WEBPACK FOOTER //
// ./src/lib/RiskMinder.js